import { render, staticRenderFns } from "./SalesOpenQuotationsTrackingTable.vue?vue&type=template&id=a46863b6"
import script from "./SalesOpenQuotationsTrackingTable.vue?vue&type=script&lang=ts"
export * from "./SalesOpenQuotationsTrackingTable.vue?vue&type=script&lang=ts"
import style0 from "./SalesOpenQuotationsTrackingTable.vue?vue&type=style&index=0&id=a46863b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports